import script from "./GroupCalls.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupCalls.vue?vue&type=script&setup=true&lang=js"

import "./GroupCalls.vue?vue&type=style&index=0&id=05c306e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c306e2"]])

export default __exports__